import React from 'react';
import styled from 'styled-components';

const ContactSection = styled.section`
  padding: 100px 10%;
  background-color: var(--color-bg-alt);

  @media (max-width: 768px) {
    padding: 80px 5%;
  }

  @media (max-width: 576px) {
    padding: 60px 5%;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: var(--color-text);
  margin-bottom: 1.5rem;
  text-align: center;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 70px;
    height: 4px;
    background-color: var(--color-primary);
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
  }
`;

const ContactWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
`;

const ContactInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    max-width: 300px;
  }
`;

const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
`;

const InfoText = styled.p`
  font-size: 1.1rem;
  color: var(--color-secondary);
  line-height: 1.7;
  margin-bottom: 2rem;

  @media (max-width: 576px) {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }
`;

const InfoItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const InfoIcon = styled.div`
  width: 50px;
  height: 50px;
  background-color: rgba(79, 140, 255, 0.1);
  color: var(--color-primary);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  font-size: 1.2rem;
`;

const InfoContent = styled.div`
  text-align: left;

  h4 {
    font-size: 1.1rem;
    color: var(--color-text);
    margin-bottom: 0.3rem;
  }

  p {
    font-size: 1rem;
    color: var(--color-secondary);
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;
`;

const SocialLink = styled.a`
  width: 40px;
  height: 40px;
  background-color: var(--color-primary);
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  transition: background 0.3s, color 0.3s;

  &:hover {
    background-color: var(--color-secondary);
    color: #fff;
  }
`;

const Contact = () => {
  return (
    <ContactSection id="contact">
      <SectionTitle>Let's Connect</SectionTitle>
      <br />

      <ContactWrapper>
        <InfoText>
          Interested in collaborating, exploring ideas, or just dropping a friendly hello—I'm all ears. I'm always excited to chat about new projects, tackle tech challenges, or simply make great connections.
        </InfoText>

        <ContactInfo>
          <InfoColumn>
            <InfoItem>
              <InfoIcon>
                <i className="fas fa-envelope"></i>
              </InfoIcon>
              <InfoContent>
                <h4>Corporate Email</h4>
                <p>surendar.vp@pansas.org</p>
              </InfoContent>
            </InfoItem>

            <InfoItem>
              <InfoIcon>
                <i className="fas fa-envelope"></i>
              </InfoIcon>
              <InfoContent>
                <h4>Personal Email</h4>
                <p>Surendar.VP@iCloud.com</p>
              </InfoContent>
            </InfoItem>
          </InfoColumn>

          <InfoColumn>
            <InfoItem>
              <InfoIcon>
                <i className="fas fa-calendar-alt"></i>
              </InfoIcon>
              <InfoContent>
                <h4>Schedule a Meeting</h4>
                <p><a href="https://calendly.com/PanSas/30min" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary)', textDecoration: 'none' }}>Book a call</a></p>
              </InfoContent>
            </InfoItem>

            <InfoItem>
              <InfoIcon>
                <i className="fas fa-map-marker-alt"></i>
              </InfoIcon>
              <InfoContent>
                <h4>Location</h4>
                <p>Mountain View, CA, USA</p>
              </InfoContent>
            </InfoItem>
          </InfoColumn>
        </ContactInfo>

        <SocialLinks>
            <SocialLink
              href="https://www.linkedin.com/in/surendarvp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in"></i>
            </SocialLink>
            <SocialLink
              href="https://x.com/vpsurendar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </SocialLink>
            <SocialLink
              href="https://pansas.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/pansas_logo.webp" alt="PanSas" style={{ height: '20px', filter: 'brightness(0) invert(1)' }} />
            </SocialLink>
        </SocialLinks>
      </ContactWrapper>
    </ContactSection>
  );
};

export default Contact;
